import { useEffect, useState } from 'react';

// 创建一个全局缓存对象
const svgCache = new Map();

const Svg = ({ src, ...props }) => {
  const [svgContent, setSvgContent] = useState(() => svgCache.get(src));

  useEffect(() => {
    // 如果缓存中已存在，直接返回
    if (svgCache.has(src)) {
      setSvgContent(svgCache.get(src));
      return;
    }

    const fetchSvg = async () => {
      try {
        // 检查是否有其他实例正在获取相同的SVG
        if (svgCache.get(src) === 'pending') {
          return;
        }

        // 标记为正在获取
        svgCache.set(src, 'pending');

        const response = await fetch(src);
        if (!response.ok) {
          throw new Error(`Failed to fetch SVG: ${response.statusText}`);
        }

        const svgText = await response.text();

        // 简单的SVG验证
        if (!svgText.includes('<svg')) {
          throw new Error('Invalid SVG content');
        }

        // 存入缓存
        svgCache.set(src, svgText);
        setSvgContent(svgText);
      } catch (error) {
        console.error('Error fetching SVG:', error);
        // 从缓存中移除失败的请求
        svgCache.delete(src);
        setSvgContent(null);
      }
    };

    fetchSvg();

    // 清理函数
    return () => {
      // 如果组件卸载时请求还在pending状态，从缓存中移除
      if (svgCache.get(src) === 'pending') {
        svgCache.delete(src);
      }
    };
  }, [src]);

  if (!svgContent || svgContent === 'pending') {
    return null; // 或者返回一个加载指示器
  }

  return (
    <div
      {...props}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};

// 添加预加载方法
Svg.preload = async (urls) => {
  const promises = urls.map(async (url) => {
    if (svgCache.has(url)) {
      return;
    }

    try {
      const response = await fetch(url);
      const svgText = await response.text();
      svgCache.set(url, svgText);
    } catch (error) {
      console.error(`Error preloading SVG ${url}:`, error);
    }
  });

  await Promise.all(promises);
};

// 添加清除缓存方法
Svg.clearCache = () => {
  svgCache.clear();
};

export default Svg;